import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27e8cd78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status_div" }
const _hoisted_2 = { class: "step_div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Payment is processing", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Payment Successful", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pending Dispatch", -1))
const _hoisted_7 = { class: "btn_div" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("View order")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Buy More")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_menu = _resolveComponent("header-menu")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_header_menu, {
      title: "Payment Status",
      backgroundColor: "white",
      fontColor: "#190900"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_steps, {
        "icon-size": "20px",
        direction: "vertical",
        active: $setup.pay_datas.status
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_step, null, {
            default: _withCtx(() => [
              _hoisted_3,
              ($setup.pay_datas.status !== 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Kindly pay full amount within 2 hours or the order will be auto cancelled."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_van_step, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_van_step, null, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createVNode(_component_van_button, {
          onClick: $setup.actv_order_list_fn,
          plain: "",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_van_button, {
          onClick: $setup.actv_home_fn,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}